<template>
  <div class="cehsi888">
    <div class="shopTableTop">
      <div style="width:180px;">{{ $t('shopping.picture') }}</div>
      <div style="width:320px;">{{ $t('shopping.info') }}</div>
      <div style="width:110px;">{{ $t('shopping.place') }}</div>
      <div style="width:80px;">{{ $t('shopping.stock') }}</div>
      <div style="width:100px;">{{ $t('shopping.price') }}</div>
      <div style="width:110px;">{{ $t('shopping.Purchase') }}</div>
      <div style="width:100px">{{ $t('shopping.Subtotal') }}</div>
      <div style="flex:1">{{ $t('shopping.operate') }}</div>
    </div>
    <div v-if="tableData.length === 0">
      <Spin size="large" fix v-if="spinShow"></Spin>
      <div class="noDate">
        <div>
          <!--        <span class="iconfont icon-a-zu420"></span>-->
          <div class="emptyCartImage">
            <img src="@/assets/images/shoppingCart/emptyCart.png"/>
          </div>
          <div class="flex">
            <div class="shoppingNull">
              <div class="center">
                <span class="iconfont icon-gantanhao-xianxingyuankuang"></span>
              </div>
              <span>{{ $t('shopping.Sorry') }} </span>
            </div>
            <div class="ml10">
              <Button type="primary" @click="goHome">{{ $t('home.return') }} </Button>
            </div>
          </div>
          <!--        <div class="goHome">-->
          <!--          <div @click="goHome">返回首页逛逛</div>-->
          <!--        </div>-->
        </div>
      </div>
    </div>
    <div>
      <Spin size="large" fix v-if="spinShow"></Spin>
      <vxe-table
        v-if="tableData.length>0"
        resizable
        ref="xTable"
        border="inner"
        align="center"
        :show-header="false"
        :showIcon="true"
        :tree-config="{ expandAll: true }"
        :checkbox-config="{
          trigger: 'click',
 
          checkAll: true
        }"
        :data="tableData"
        @checkbox-change="selectChangeEvent"
        @checkbox-all="selectChangeEventAll"
        :span-method="mergeRowMethod"
      >
        <vxe-table-column type="checkbox" title="全选" width="40"></vxe-table-column>
        <vxe-table-column field="name">
          <template v-slot="{ row }">
            <div class="img" v-if="row.carBrandName" style="width:180px">
              <img
                v-if="row.img"
                :src="row.img"
                style="width: 60%; height: 100%"
              />
              <img
                v-else
                src="@/assets/images/shoppingCart/2.png"
                style="width: 60%; height: 100%"
              />
            </div>
            <div  v-else style="width:450%;text-align:left;display:flex;align-items: center">
              <span
                :class="{
                  jiapei: row.storeType != '' ? true : false
                }"
                >{{ row.storeType }}</span
              >
              <!-- <span class="iconfont icon-a-zu248"></span> -->
              <span class="iconfont icon-shangcheng red"></span>
              <!-- 这期不做 -->
              <span @click="gohomePage(row)" class="fw600 pointer"> {{ row.name }}</span>
              <!-- <span  class="fw600 pointer"> {{ row.name }}</span> -->
              <!-- <span
                
                  @click="go('im')"
                ></span> -->
              <xiaopei :oppositeTenantId="row.tenantId">
                <i class="iconfont icon-a-lujing162"></i>
              </xiaopei>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="qualityTypeName" align="left" width="280px">
          <template v-slot="{ row }">
            <!-- {{row}} -->
            <div @click="goPartsdetails(row)">
              <div>
                <span class="ycj" v-if="row.qualityTypeName">{{
                  row.qualityTypeName
                }}</span>
                <span
                  >{{ row.carBrandName }}{{ row.direction }}{{ row.stdNameJp
                  }}{{ row.oeCode }}</span
                >
                <div class="oe-p" @mouseleave="closeRelevance(row)">
                <span class="oe-w2">OE号：</span> 
                 <p
                   v-if="row.oeCodeList && row.oeCodeList.length"
                   class="oe-w1"
                    @mouseenter="getRelevance(row.partId, row)"
                   >
                    <span  >{{ row.oeCodeList[0]}}</span>
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="row.oeCodeList.length>1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="row.oeCodeList"
                  >
                    <div
                    v-if="row.oeCodeList.length>1"
                      class="relevanceBox"
                      :class="row.isShow ? 'show' : ''"
                    >
                      <p v-for="i in row.oeCodeList.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="tow">
                <li >
                  <span style="margin:0">服务：</span>
                </li>
                <li v-if="row.genuineGuarantee">
                  <span class="iconfont icon-a-lujing153"></span>
                  <!-- <p>正品保证</p> -->
                </li>
                <li v-if="row.technicalSupport">
                  <span class="iconfont icon-a-ziyuan4"></span>
                  <!-- <p>技术支持</p> -->
                </li>
                <li v-if="row.warrantyService">
                  <span class="iconfont icon-a-ziyuan5"></span>
                  <!-- <p>保修服务</p> -->
                </li>

                <li v-if="row.returnPromise">
                  <span class="iconfont icon-a-ziyuan21"></span>
                  <!-- <p>退换货承诺</p> -->
                </li>
              </ul>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="provinceName" width="110px">
          <template v-slot="{ row }">
            <!-- <div v-if="row.provinceName"> -->
              <div style="margin-bottom: 20px">
                {{ row.shipCity }}{{ row.shipStore }}
              </div>
              <!-- <div>
                <div class="time">
                  <span class="iconfont icon-shijian"></span>
                  <span>2天5小时</span>
                </div>
              </div> -->
            <!-- </div> -->
          </template>
        </vxe-table-column>
       <vxe-table-column field="stock" width="80">
          <template v-slot="{ row }">
            <div v-if="row.offerPrice">
              <div v-if="row.stock < 10&&row.stock !=0" style="line-height: 0.3">
                {{ row.stock }}{{ row.unitId }}
              </div>
              <div v-else-if="row.stock==0" style="line-height: 0.3">缺货</div>
              <div v-else>10+</div>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="offerPrice" width="100px">
          <template v-slot="{ row }">
            <div v-if="row.offerPrice">
              <div>
                <span style="color: #e90d0d">￥</span>
                <span class="money">
                  <b>{{ row.offerPrice }}</b>
                </span>
              </div>
              <div>
                <!-- <div class="time">
                    <span class="iconfont icon-shijian"></span>
                    <span>2天5小时</span>
                  </div> -->
              </div>
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column field="enquiryNum"  width="110">
          <template v-slot="{ row }">
            <div v-if="row.offerPrice" class="wpn">
              <!-- <div>{{ row.stock }}{{ row.unitId }}</div> -->
              <!-- <div> -->
              {{ row.enquiryNum }}
              <!-- </div> -->
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="totalMoney"  width="100">
          <template v-slot="{ row }">
            <div v-if="row.carBrandName">
              <!-- <span style="color: #e90d0d">￥</span> -->
              <span style="color: #e90d0d">{{ '￥' + row.totalMoney }} </span>
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <template v-slot="{ row }">
            <div class="right" v-if="row.carBrandName">
              <div @click="Delete(row)" class="pointer" style="color: #F62B4E;font-fize:14p;">删除</div>
            </div>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>

    <Affix :offset-bottom="0">
      <div v-if="!spinShow" class="addss">
        <div class="left">
          <Checkbox class="l-left" @on-change="all" v-model="single"
            >{{ $t('shopping.select') }} </Checkbox
          >
          <span @click="deleAll" class="pointer">{{ $t('shopping.delete') }} </span>
        </div>
        <div class="right">
          <span>
            {{ $t('shopping.selected') }}
            <span style="color: red">{{ leng }}</span>
            {{ $t('shopping.pieces') }}
          </span>
          <span class="l-right"> {{ $t('shopping.Total') }} </span>
          <span style="color: red; display: inline-block">￥</span>
          <span class="m-right">{{ totalPrice }}</span>
          <button v-noresub="1000" v-if="!c" :class="tableData.length===0?'r-right bgDisabled':'r-right'" :disabled="tableData.length === 0" @click="end">
             {{ $t('shopping.settlement') }}
          </button>
          <button v-noresub="1000" v-else :class="tableData.length===0?'r-right bgDisabled':'r-right'" :disabled="tableData.length === 0" @click="ends">
             {{ $t('shopping.settlement') }}
          </button>
          <!-- <span v-if="!c" class="r-right" @click="end"> 结算 </span>
            <span v-else class="r-right" @click="ends"> 结算 </span> -->
        </div>
      </div>

      <!-- <div v-else>
          <div v-if="!spinShow" class="addss">
            <div class="left">
              <Checkbox class="l-left" @on-change="all" v-model="single"
                >全选dsadasdasdasdas</Checkbox
              >
              <span @click="deleAll">删除</span>
            </div>
            <div class="right">
              <span>
                已选商品
                <span style="color: red">{{ leng }}</span>
                件
              </span>
              <span class="l-right"> 合计 (不含运费)： </span>
              <span style="color: red; display: inline-block">￥</span>
              <span class="m-right">{{ totalPrice }}</span>
              <span class="r-right" @click="ends"> 结算 </span>
            </div>
          </div>
        </div> -->
    </Affix>
    <div class="footer">
      <div>
        {{ $t('shopping.Expired') }} 
        <span class="noshopping">{{ this.failureNum }}</span>
       {{ $t('shopping.pieces') }}
      </div>
    </div>
    <vxe-table
      resizable
      ref="xTables"
      border="inner"
      align="center"
      :show-header="false"
      :showIcon="true"
      :tree-config="{ expandAll: true }"
      :data="tableData2"
      :span-method="mergeRowMethod"
    >
      <vxe-table-column field="name" width="240px">
        <template v-slot="{ row }">
          <div class="img" v-if="row.carBrandName" style="width:180px">
            <img
              v-if="row.img"
              :src="row.img"
              style="width: 60%; height: 100%"
            />
            <img
              v-else
              src="@/assets/images/shoppingCart/2.png"
              style="width: 60%; height: 100%"
            />
          </div>
          <div  v-else style="width:450%;text-align:left;display:flex;align-items: center">
            <span
              :class="{
                jiapei: row.storeType != '' ? true : false
              }"
              >{{ row.storeType }}</span
            >
            <!-- <span class="iconfont icon-a-zu248"></span> -->
            <span class="iconfont icon-shangcheng red"></span>
            <!-- 这期不做 -->
            <span @click="gohomePage(row)" class="fw600 pointer"> {{ row.name }}</span>
            <!-- <span class="fw600 pointer"> {{ row.name }}</span> -->
            <xiaopei :oppositeTenantId="row.tenantId">
              <i class="iconfont icon-a-lujing162"></i>
            </xiaopei>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="qualityTypeName" align="left" width="330px">
        <template v-slot="{ row }">
          <div @click="goPartsdetails(row)">
            <div class="w22">
              <span class="ycj" v-if="row.qualityTypeName">{{
                row.qualityTypeName
              }}</span>
              <span
                >{{ row.carBrandName }}{{ row.direction }}{{ row.stdNameJp
                }}{{ row.oeCode }}</span
              >
              <div class="oe-p" @mouseleave="closeRelevance(row)">
                <p>OE号：22222</p> 
                 <p
                 v-if="row.oeCodeList && row.oeCodeList.length > 0"
                   class="oe-w1"
                    @mouseenter="getRelevance(row.partId, row)"
                   >
                    <span  >{{ row.oeCodeList[0]}}</span>
                    <i
                      class="ivu-icon ivu-icon-ios-arrow-down"
                      v-if="row.oeCodeList.length > 1"
                    ></i>
                  </p>
                  <div
                    class="relevance"
                    :tabIndex="1"
                    v-if="row.oeCodeList"
                  >
                    <div
                    v-if="row.oeCodeList.length>1"
                      class="relevanceBox"
                      :class="row.isShow ? 'show' : ''"
                    >
                      <p v-for="i in row.oeCodeList.slice(1)" :key="i">
                        {{ i }}
                      </p>
                    </div>
                  </div>
                </div>
            </div>
            <ul class="tow">
               <li >
                  <span style="margin:0">服务：</span>
                </li>
              <li v-if="row.genuineGuarantee">
                <span class="iconfont icon-a-lujing153"></span>
                <!-- <p>正品保证</p> -->
              </li>
              <li v-if="row.technicalSupport">
                <span class="iconfont icon-a-ziyuan4"></span>
                <!-- <p>技术支持</p> -->
              </li>
              <li v-if="row.warrantyService">
                <span class="iconfont icon-a-ziyuan5"></span>
                <!-- <p>保修服务</p> -->
              </li>

              <li v-if="row.returnPromise">
                <span class="iconfont icon-a-ziyuan21"></span>
                <p>退换货承诺</p>
              </li>
            </ul>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="provinceName" width="160px">
        <template v-slot="{ row }">
          <!-- <div v-if="row.provinceName"> -->
            <div style="margin-bottom: 20px">
              {{ row.shipCity }}{{ row.shipStore }}
            </div>
          <!-- </div> -->
        </template>
      </vxe-table-column>
      <vxe-table-column field="offerPrice" width="100px">
        <template v-slot="{ row }">
          <div v-if="row.offerPrice">
            <div>
              <span style="color: #e90d0d">￥</span>
              <span class="money">
                <b>{{ row.offerPrice }}</b>
              </span>
            </div>
            <!-- <div>
                <div class="time">
                  <span class="iconfont icon-shijian"></span>
                  <span>2天5小时</span>
                </div>
              </div> -->
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="enquiryNum" width="70px">
        <template v-slot="{ row }">
          <div v-if="row.offerPrice" class="wpn">
            {{ row.enquiryNum }}
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column width="170px">
        <template v-slot="{ row }">
          <div v-if="row.status == 3">商品已下架</div>
          <div v-if="row.status == 2">报价已过期</div>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <template v-slot="{ row }">
          <div class="right" v-if="!row.children">
            <div @click="Delete(row)" class="pointer" style="color: #F62B4E;">删除</div>
            <div @click="same(row)" class="pointer">找同款</div>
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import xiaopei from '@/views/xiaopei/index.vue'
import {
  getenquirycart,
  // firstShopping,
  getenquirycartdele,
  tableListPostxj
} from '@/api/shoppingCart/shoppingCart.js'
export default {
  props: { failureNum: Number },
  data() {
    return {
      tableData: [], // 有效的数据
      spinShow: false, // 显示有效的数据
      select: [], // 选中的数据
      tableDataID: [], // 对比的数据
      carids: [], // 购物车的id
      single: true,
      leng: '0',
      totalPrice: '0.00',
      invalidShoppingTotal: 0,
      vxeAllChecked: null,
      tableData2: [],
      c: true
    }
  },
  components: { xiaopei },
  mounted() {
    // 刷新页面时，Affix不显示bug
    window.onbeforeunload = function(e) {
      e = e || window.event
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        window.scrollBy(0, 1)
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      window.scrollBy(0, 1)
    }

    // iview 中 Affix 一开始不显示的bug 需要滚动页面
    window.scrollBy(0, 1)
    this.enquirydata()
  },
  created() {},
  watch: {
    vxeAllChecked(val, oldVal) {
      this.single = val
    }
  },
  methods: {
    //将多列合并成一行
    mergeRowMethod({row, $rowIndex, column, data}) { 
      let fieldser = ['name']
      let cellValue = row[column.property]
      if(cellValue && fieldser.includes(column.property)){
          return {rowspan: 1, colspan: 8};
      }else{
        return {rowspan: 1, colspan: 1};
      }
    },
    // 控制按钮是否可以点击
    checkMethod(row) {
      // return row.row.stock != 0
    },
    // 购物车询价数据
    async enquirydata(num) {
      this.spinShow = true
      const res = await getenquirycart()
      console.log(res)
      if (res.status) {
        // console.log('成功')
        this.tableData = res.data.valid
        this.tableData2 = res.data.invalid
        // this.tableData2 = res.data.valid
        if (num === 2) {
          // 渲染不折叠
          this.tableData.length>0?this.$refs.xTable.reloadData(this.tableData):''
          this.tableData2.length>0?this.$refs.xTables.reloadData(this.tableData2):''
        }
        this.traversaldata(this.tableData)
        this.shopstart()
        this.xiaoshu(this.tableData)
        this.xiaoshu(this.tableData2)
        this.spinShow = false
      } else {
        this.spinShow = false
      }
    },
    // 点击事件对比
    traversaldata(val) {
      val.filter(item => {
        if (item.id) {
          this.tableDataID.push(item.id)
        }
        if (item.children && item.children.length > 0) {
          this.traversaldata(item.children)
        }
      })
      let set = new Set(this.tableDataID)
      this.tableDataID = Array.from(set)
    },
    // 显示的显示
    xiaoshu(tab) {
      tab.filter(el => {
        if (el.partCurrentAmount) {
          // this.tableDataID.push(el.id)
          el.offerPrice = el.offerPrice.toFixed(2)
          el.totalMoney = el.totalMoney.toFixed(2)
        }
        if (el.children && el.children.length > 0) {
          this.xiaoshu(el.children)
        }
      })
    },
    // 返回首页
    goHome() {
      this.$router.push('supportself')
    },
    // 一开始就计算出商品数量和总价
    shopstart() {
      this.select = []
      this.tableData.filter(el => {
        el.children.filter(el => {
          this.select.push(el)
        })
      })
      let shopdata = this.select.filter(item => {
        return item.carBrandName != null
      })
      this.leng = shopdata.length
      let a = 0
      shopdata.forEach(item => {
        // console.log();
        a += parseFloat(item.totalMoney)
      })
      // console.log(shopdata);
      // console.log(a);
      this.totalPrice = a.toFixed(2) || 0
      // console.log(this.totalPrice);
    },
    //  change 事件
    selectChangeEvent({ records }) {
      this.c = false
      this.select = records
      let cd = records.filter(el => {
        return el.id != undefined
      })
      console.log(cd)
      console.log(this.tableDataID)
      if (cd.length === this.tableDataID.length) {
        this.single = true
      } else {
        this.single = false
      }

      let a = []
      a = this.select.filter(el => {
        return el.carBrandName != null
      })
      this.leng = a.length
      let e = 0
      a.forEach(el => {
        e += parseFloat(el.totalMoney)
      })
      this.totalPrice = e.toFixed(2) || 0
    },
    // vxe-table  自带的全选事件
    selectChangeEventAll({ checked }) {
      this.vxeAllChecked = checked
      this.single = checked
    },
    // 店铺的跳转
    gohomePage(row) {
      this.$router.push({
        path: '/homePage',
        query: {
          shopId: row.shopId,
          tenantId: row.tenantId,
          shopName: row.name
        }
      })
    },
    // 跳转到商品详情
    goPartsdetails(row) {
      console.log(row);
       if(row.storeId){
      const { href } = this.$router.resolve({
        path: '/Partsdetails',
        query: { partId: row.partId, leagueId:row.tenantId,storeId:row.storeId }
      })
      window.open(href, '_self', console.log(href))
      }else{
      const { href } = this.$router.resolve({
        path: '/Partsdetails',
        query: { partId: row.partId,  }
      })
      window.open(href, '_self', console.log(href))
      }
      this.$router.push({
        path: '/Partsdetails',
        query: {
          partId: row.partId
        }
      })
    },
    // 全选
    all(val) {
      this.c = false
      this.allState = val
      this.$refs.xTable.setAllCheckboxRow(val)
      this.getSelectEvent1()
    },
    // 全选时候的数据
    getSelectEvent1() {
      this.select = this.$refs.xTable.getCheckboxRecords()
      let a = []
      a = this.select.filter(el => {
        return el.carBrandName != null
      })
      this.leng = a.length
      let e = 0
      a.forEach(el => {
        e += parseFloat(el.totalMoney)
      })
      this.totalPrice = e.toFixed(2) || 0
    },
    // 删除本条数据
    Delete(row) {
      this.$Modal.confirm({
        title: '是否删除',
        onOk: async () => {
          // this.spinShow = true
          let data = [row.id]
          console.log(data)
          let res = await getenquirycartdele(data)
          if (res.status) {
            this.enquirydata(2)
            this.$emit('getcardnum')
            this.$emit('carsx')
            this.$Message.info('已删除')
          } else {
            this.$Message.error('删除失败')
          }
        },
        onCancel: () => {
          this.$Message.warning('已取消')
        }
      })
    },
    // 多个删除
    deleAll() {
      let a = []
      a = this.select.filter(el => {
        return el.carBrandName != null
      })
      let data = []
      a.forEach(el => {
        data.push(el.id)
      })
      if (data.length > 0) {
        this.$Modal.confirm({
          title: '是否要删除',
          onOk: async () => {
            this.spinShow = true
            let res = await getenquirycartdele(data)
            if (res.status) {
              this.enquirydata(2)
              this.$emit('getcardnum')
              this.$emit('carsx')
              this.$Message.info('删除成功')
            } else {
              this.$Message.error('删除失败')
            }
          }
        })
      } else {
        this.$Message.error('请选中一条数据')
      }
      console.log('啥共和国')
    },
    // 删除的
    async end() {
      let a = []
      a = this.select.filter(el => {
        return el.carBrandName != null
      })
      let c = []
      a.forEach(el => {
        c.push(el.id)
      })
      let data = c
      let params = {}
      const res = await tableListPostxj(params, data)
      sessionStorage.setItem('indent', JSON.stringify(res.data))
      if (res.status) {
        this.$router.push({
          path: '/orderInformation'
        })
      }
    },
    // 进来删除的
    async ends() {
      let c = []
      this.tableData.filter(el => {
        el.children.filter(el => {
          c.push(el.id)
        })
      })
      let data = c
      let params = {}
      let res = await tableListPostxj(params, data)
      sessionStorage.setItem('indent', JSON.stringify(res.data))
      if (res.status) {
        this.$router.push({
          path: '/orderInformation'
        })
      }
    },
    // 找同款
    same(row) {
      this.$router.push({
        path: '/partsSearch',
        query: { searchContent: row.partCode }
      })
    },
            // 展开
     getRelevance(partId, row) {
      console.log(partId)
      console.log(row.isShow)
      // row.isShow = true
      this.$set(row, 'isShow', true)
      // console.log(row.isShow);
      // console.log(row);
    },
    // 关闭oe
    closeRelevance(row) {
      this.$set(row, 'isShow', false)
    },
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
